(() => {
  let activeOpener;
  function place(dialog) {
    if (!activeOpener || document.body.classList.contains('upup-home')) return;
    const anchor = activeOpener.getBoundingClientRect();
    const box = dialog.getBoundingClientRect();
    const gap = 12;
    dialog.style.left = `${Math.max(gap, Math.min(anchor.right - box.width, innerWidth - box.width - gap))}px`;
    dialog.style.top = `${Math.max(gap, Math.min(anchor.bottom + 8, innerHeight - box.height - gap))}px`;
  }
  function close(dialog, restoreFocus) {
    dialog.close();
    document.querySelectorAll('[data-open-wechat]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    if (restoreFocus) activeOpener?.focus({preventScroll: true});
  }
  document.addEventListener('click', (event) => {
    const dialog = document.getElementById('WechatDialog');
    if (!dialog) return;
    const opener = event.target.closest('[data-open-wechat]');
    if (opener && !opener.disabled) {
      if (dialog.open) { close(dialog, true); return; }
      activeOpener = opener;
      dialog.show();
      document.querySelectorAll('[data-open-wechat]').forEach(el => el.setAttribute('aria-expanded', 'true'));
      place(dialog);
      if (document.body.classList.contains('upup-home')) dialog.scrollIntoView({block:'center', behavior:'instant'});
      return;
    }
    if (event.target.closest('[data-close-wechat]')) close(dialog, true);
    else if (dialog.open && !dialog.contains(event.target)) close(dialog, false);
  });
  document.addEventListener('keydown', (event) => {
    const dialog = document.getElementById('WechatDialog');
    if (event.key === 'Escape' && document.body.classList.contains('upup-home')) document.querySelector('[data-saved-dialog]')?.close();
    if (event.key === 'Escape' && dialog?.open) { close(dialog, true); event.preventDefault(); }
  });
  window.addEventListener('resize', () => {
    const dialog = document.getElementById('WechatDialog');
    if (dialog?.open) place(dialog);
  });
  window.addEventListener('scroll', () => {
    const dialog = document.getElementById('WechatDialog');
    if (dialog?.open && !document.body.classList.contains('upup-home')) close(dialog, false);
  }, {passive: true});
})();
